var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_5166_5027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9293 2.00143C18.8988 1.92523 18.834 1.86809 18.7578 1.84143L15.0397 0.561425C14.9331 0.527139 14.815 0.553806 14.7388 0.637616C14.6626 0.721425 14.6397 0.83952 14.6816 0.942378L15.1578 2.08143L1.22641 7.74619C1.11974 7.78809 1.04736 7.89476 1.04736 8.00904V10.3824C1.04736 10.4776 1.09308 10.5652 1.17308 10.6186C1.21879 10.649 1.27593 10.6681 1.33308 10.6681C1.37117 10.6681 1.40546 10.6605 1.43974 10.6452L16.2169 4.61857L16.6931 5.76523C16.735 5.86809 16.8378 5.93666 16.9483 5.94047C17.0702 5.93285 17.1655 5.87952 17.215 5.78047L18.9216 2.23762C18.9597 2.16143 18.9597 2.07762 18.9293 2.00143Z",
    fill: "url(#paint0_linear_5166_5027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9517 9.12889C18.9517 8.24889 17.2184 8.0127 16.1936 8.0127C15.1689 8.0127 13.4355 8.24889 13.4355 9.12889V10.2108C13.4355 11.1822 15.9117 11.2089 16.1936 11.2089C16.4755 11.2089 18.9517 11.1822 18.9517 10.2108V9.12889ZM16.1936 8.58412C17.6565 8.58412 18.3917 8.98031 18.4336 9.12127C18.3879 9.27746 17.6565 9.67365 16.1936 9.67365C16.0108 9.67365 15.8394 9.66603 15.6794 9.6546C14.5632 9.57841 13.9994 9.26222 13.9536 9.12889C14.007 8.9727 14.7384 8.58412 16.1936 8.58412Z",
    fill: "url(#paint1_linear_5166_5027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8769 11.248C18.7283 11.3395 18.5645 11.4119 18.3893 11.4766C18.416 11.4995 18.4312 11.5223 18.435 11.5376C18.3893 11.6938 17.6579 12.09 16.1912 12.09C16.0083 12.09 15.8369 12.0823 15.6769 12.0709C14.5607 11.9947 13.9969 11.6785 13.9512 11.5452C13.9588 11.5261 13.9741 11.5033 14.0045 11.4766C13.8255 11.4119 13.6579 11.3395 13.5093 11.248C13.4598 11.3357 13.4331 11.4347 13.4331 11.5452V12.6271C13.4331 13.5985 15.9093 13.6252 16.1912 13.6252C16.4731 13.6252 18.9493 13.5985 18.9493 12.6271V11.5452C18.9531 11.4347 18.9264 11.3395 18.8769 11.248Z",
    fill: "url(#paint2_linear_5166_5027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8769 16.0732C18.7283 16.1647 18.5645 16.2371 18.3893 16.3018C18.416 16.3247 18.4312 16.3475 18.435 16.3628C18.3893 16.519 17.6579 16.9151 16.1912 16.9151C16.0083 16.9151 15.8369 16.9075 15.6769 16.8961C14.5607 16.8199 13.9969 16.5037 13.9512 16.3704C13.9588 16.3513 13.9741 16.3285 14.0045 16.3018C13.8255 16.2371 13.6579 16.1647 13.5093 16.0732C13.4598 16.1609 13.4331 16.2599 13.4331 16.3704V17.4523C13.4331 18.4237 15.9093 18.4504 16.1912 18.4504C16.4731 18.4504 18.9493 18.4237 18.9493 17.4523V16.3704C18.9531 16.2599 18.9264 16.1647 18.8769 16.0732Z",
    fill: "url(#paint3_linear_5166_5027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8807 13.6631C18.7322 13.7545 18.5683 13.8269 18.3931 13.8917C18.4198 13.9145 18.435 13.9374 18.4388 13.9526C18.3931 14.1088 17.6617 14.505 16.195 14.505C16.0122 14.505 15.8407 14.4974 15.6807 14.4859C14.5645 14.4098 14.0007 14.0936 13.955 13.9602C13.9626 13.9412 13.9779 13.9183 14.0045 13.8917C13.8255 13.8269 13.6579 13.7545 13.5093 13.6631C13.4636 13.7507 13.4331 13.8498 13.4331 13.9602V15.0421C13.4331 16.0136 15.9093 16.0402 16.1912 16.0402C16.4731 16.0402 18.9493 16.0136 18.9493 15.0421V13.9564C18.9531 13.8498 18.9264 13.7507 18.8807 13.6631Z",
    fill: "url(#paint4_linear_5166_5027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7613 11.5439C12.7613 10.6639 11.028 10.4277 10.0032 10.4277C8.97845 10.4277 7.24512 10.6639 7.24512 11.5439V12.6258C7.24512 13.5973 9.72131 13.6239 10.0032 13.6239C10.2851 13.6239 12.7613 13.5973 12.7613 12.6258V11.5439ZM9.9994 10.9992C11.4623 10.9992 12.1975 11.3954 12.2394 11.5363C12.1937 11.6925 11.4623 12.0887 9.9994 12.0887C9.81655 12.0887 9.64512 12.0811 9.48512 12.0696C8.36893 11.9934 7.80512 11.6773 7.7594 11.5439C7.81655 11.3877 8.54797 10.9992 9.9994 10.9992Z",
    fill: "url(#paint5_linear_5166_5027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6851 16.0732C12.5365 16.1647 12.3727 16.2371 12.1975 16.3018C12.2242 16.3247 12.2394 16.3475 12.2432 16.3628C12.1975 16.519 11.4661 16.9151 10.0032 16.9151C9.82036 16.9151 9.64893 16.9075 9.48893 16.8961C8.37274 16.8199 7.80893 16.5037 7.76321 16.3704C7.77083 16.3513 7.78607 16.3285 7.81655 16.3018C7.6375 16.2371 7.46988 16.1647 7.32131 16.0732C7.27559 16.1609 7.24512 16.2599 7.24512 16.3704V17.4523C7.24512 18.4237 9.72131 18.4504 10.0032 18.4504C10.2851 18.4504 12.7613 18.4237 12.7613 17.4523V16.3704C12.7613 16.2599 12.7346 16.1647 12.6851 16.0732Z",
    fill: "url(#paint6_linear_5166_5027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6865 13.6631C12.5379 13.7545 12.3741 13.8269 12.1989 13.8917C12.2255 13.9145 12.2408 13.9374 12.2446 13.9526C12.1989 14.1088 11.4674 14.505 10.0046 14.505C9.82172 14.505 9.65029 14.4974 9.49029 14.4859C8.3741 14.4098 7.81029 14.0936 7.76458 13.9602C7.7722 13.9412 7.78744 13.9183 7.8141 13.8917C7.63506 13.8269 7.46744 13.7545 7.31887 13.6631C7.27315 13.7507 7.24268 13.8498 7.24268 13.9602V15.0421C7.24268 16.0136 9.71887 16.0402 10.0008 16.0402C10.2827 16.0402 12.7589 16.0136 12.7589 15.0421V13.9564C12.7627 13.8498 12.736 13.7507 12.6865 13.6631Z",
    fill: "url(#paint7_linear_5166_5027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49117 16.0732C6.3426 16.1647 6.17879 16.2371 6.00355 16.3018C6.03022 16.3247 6.04546 16.3475 6.04927 16.3628C6.00355 16.519 5.27213 16.9151 3.80546 16.9151C3.6226 16.9151 3.45117 16.9075 3.29117 16.8961C2.17498 16.8199 1.61117 16.5037 1.56546 16.3704C1.57308 16.3513 1.58832 16.3285 1.61879 16.3018C1.43974 16.2371 1.27213 16.1647 1.12355 16.0732C1.07403 16.1609 1.04736 16.2599 1.04736 16.3704V17.4523C1.04736 18.4237 3.52355 18.4504 3.80546 18.4504C4.08736 18.4504 6.56355 18.4237 6.56355 17.4523V16.3704C6.56355 16.2599 6.53689 16.1647 6.49117 16.0732Z",
    fill: "url(#paint8_linear_5166_5027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56355 13.957C6.56355 13.077 4.83022 12.8408 3.80546 12.8408C2.7807 12.8408 1.04736 13.077 1.04736 13.957V15.0389C1.04736 16.0103 3.52355 16.037 3.80546 16.037C4.08736 16.037 6.56355 16.0103 6.56355 15.0389V13.957ZM3.80546 13.4122C5.26832 13.4122 6.00355 13.8084 6.04546 13.9494C5.99974 14.1056 5.26832 14.5018 3.80546 14.5018C3.6226 14.5018 3.45117 14.4942 3.29117 14.4827C2.17498 14.4065 1.61117 14.0903 1.56546 13.957C1.6226 13.8008 2.35022 13.4122 3.80546 13.4122Z",
    fill: "url(#paint9_linear_5166_5027)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5166_5027",
    x1: 9.99931,
    y1: 0.546875,
    x2: 9.99931,
    y2: 10.6681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5166_5027",
    x1: 16.1936,
    y1: 8.0127,
    x2: 16.1936,
    y2: 11.2089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5166_5027",
    x1: 16.1914,
    y1: 11.248,
    x2: 16.1914,
    y2: 13.6252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5166_5027",
    x1: 16.1914,
    y1: 16.0732,
    x2: 16.1914,
    y2: 18.4504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5166_5027",
    x1: 16.1914,
    y1: 13.6631,
    x2: 16.1914,
    y2: 16.0402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5166_5027",
    x1: 10.0032,
    y1: 10.4277,
    x2: 10.0032,
    y2: 13.6239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5166_5027",
    x1: 10.0032,
    y1: 16.0732,
    x2: 10.0032,
    y2: 18.4504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5166_5027",
    x1: 10.001,
    y1: 13.6631,
    x2: 10.001,
    y2: 16.0402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5166_5027",
    x1: 3.80546,
    y1: 16.0732,
    x2: 3.80546,
    y2: 18.4504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5166_5027",
    x1: 3.80546,
    y1: 12.8408,
    x2: 3.80546,
    y2: 16.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5166_5027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2857,
    height: 18.2857,
    fill: "white",
    transform: "translate(0.856934 0.357422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataInsight);
export default __webpack_public_path__ + "static/media/data-insight.3b94929914314efbbff46fa455cd2c81.svg";
export { ForwardRef as ReactComponent };